<template lang="html">
<div class="pgInner attesEdit">

    <div class="headBar">审核</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

               <table class="tabs">
                    <tr>
                         <td class="ispan1">企业全称：</td>
                         <td class="ispan2 itext">{{attesInfo.companyName}}</td>

                         <td class="ispan1">申请人：</td>
                         <td class="itext">{{attesInfo.applicantName}}</td>
                    </tr>
                    <tr>
                         <td class="ispan1">创建人：</td>
                         <td class="ispan2 itext">{{enterprise.founder}}</td>
                         <td>主体类型：</td>
                         <td class="itext">{{attesInfo.subjectType}}</td>
                    </tr>
                    <tr>
                         <td>行业：</td>
                         <td class="itext">{{enterprise.industryDirection}}</td>
                    </tr>
                    <tr>
                         <td>有效证件：</td>
                         <td>
                            <!-- <el-button type="primary" size="mini">查看</el-button> -->
                            <el-image
                              style="width: 100px; height: 100px"
                              :src="imgurl1"
                              :preview-src-list="imgarr1">
                            </el-image>
                         </td>

                         <td>认证公函：</td>
                         <td>
                           <el-image
                             style="width: 100px; height: 100px"
                             :src="imgurl2"
                             :preview-src-list="imgarr2">
                           </el-image>
                         </td>
                    </tr>
                    <tr>
                         <td>身份类别：</td>
                         <td colspan="3">
                           <all-select code="sflx"
                                :selectId="attesInfo.identityTypeId"
                                paramsKey="identityType"
                                @selectChange="selectChange"
                                plaText="身份类别" />
                         </td>
                    </tr>
                    <tr class="stateLine">
                         <td>审核：</td>
                         <td colspan="3">
                             <el-radio-group v-model="params.status">
                                <el-radio value="2" :label="2">通过</el-radio>
                                <el-radio value="4" :label="4">不通过</el-radio>
                             </el-radio-group>
                         </td>
                    </tr>
                    <tr v-if="params.status==4">
                         <td></td>
                         <td colspan="3">
                            <el-input
                              type="textarea"
                              :rows="5"
                              placeholder="请输入内容"
                              v-model="params.auditFailureReasons">
                            </el-input>
                         </td>
                    </tr>
               </table>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 3">初始化中...</span>
           <span v-if="pgState == 4">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="goCreate" type="primary" size="small">提交</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import { getEnterpriseAttes,attesUptate } from "@/api/attes/attestation";
import { createEntUser,entUserItem } from "@/api/enterprise/index";
import { mapState } from 'vuex';
export default {

    computed:{
      ...mapState('imgStore',{
          imgurl1 (state) {
              if(this.params.applicationCertDocId){
                  let idarr = this.params.applicationCertDocId.split(',');
                  return state.vmUrl + '/id/' + idarr[0] + '/token/' + state.vmToken;
              }else{
                  return '';
              }
          },
          imgarr1 (state) {
              if(this.params.applicationCertDocId){
                  let urlArr = [];
                  let idarr = this.params.applicationCertDocId.split(',');
                  idarr.forEach((item,i) => {
                      urlArr.push(state.vmUrl + '/id/' + item + '/token/' + state.vmToken)
                  });
                  return urlArr;
              }else{
                  return [];
              }
          },
          imgurl2 (state) {
              if(this.params.applicationCertTempleteDocId){
                  return state.vmUrl + '/id/' + this.params.applicationCertTempleteDocId + '/token/' + state.vmToken;
              }else{
                  return '';
              }
          },
          imgarr2 (state) {
              if(this.params.applicationCertTempleteDocId){
                  let urlArr = [];
                  urlArr.push(state.vmUrl + '/id/' + this.params.applicationCertTempleteDocId + '/token/' + state.vmToken);
                  return urlArr;
              }else{
                  return [];
              }
          },
      }),
      pgState:function(){
          var state = 0;
          if(this.params.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }

          return state;
      }
    },
    data(){
        return{

            pageH:'',
            selectArr:[],
            uploadIng:false,
            readyKey:false,

            attesInfo:{},
            enterprise:{},

            params:{
               ids:[],
               status:'',
               identityType:'',
               identityTypeId:'',
               subjectType:'',
               subjectTypeId:'',
               auditFailureReasons:'',
               applicationCertDocId:'',
               applicationCertTempleteDocId:'',

            },

            preCode:'',
            pgName:'',

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        selectChange:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },

        goCreate:function(){  // 创建
            var vues = this;
            if(!this.params.status){
                this.$message.error('请选择审核状态');
            }else if(this.params.status == 4 && !this.params.auditFailureReasons){
                this.$message.error('请填写原因');
            }else{
                this.uploadIng = true;

                if(vues.params.status==4){
                    vues.params.identityType='';
                    vues.params.identityTypeId='';
                }
                if(this.attesInfo.userId){
                    let idarr = this.attesInfo.userId.split(',');
                    
                    
                    (async () => {
                        try {
                            
                          await attesUptate(vues.params);

                          let params1 =  (await entUserItem({id:idarr[0]})).enterprisePerson;
                          params1.isAdmin = 1;
                          params1.adminType = 1;

                          await createEntUser({enterprisePerson:params1});

                          let params2 = (await entUserItem({id:idarr[1]})).enterprisePerson;
                          params2.isAdmin = 2;
                          params2.adminType = 0;

                          await createEntUser({enterprisePerson:params2});
                        } catch (e) {
                            vues.$message.error('保存错误！');
                        } finally {
                            vues.$router.push('attes_list');
                        }
                    })();
                }else{
                    attesUptate(vues.params).then(res => {
                        vues.$router.push('attes_list');
                    });
                };

            }


        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate();
                    vues.preCode = nowCode;
                }
            },60000)
        },

        imgChange:function(e){
            this.params.coverImage = e;
        },

        getUrl:function(){

        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            getEnterpriseAttes({id:querys.id}).then(res => {
                vues.attesInfo = res.enterpriseCertificationInfo;
                vues.enterprise = res.enterprise;
                vues.readyKey = true;

                vues.params.ids = [querys.id];

                for(var key in vues.params){
                    if(vues.attesInfo[key]){
                        vues.params[key] = vues.attesInfo[key];
                    }
                };

                if(res.enterpriseCertificationInfo.applicationCertDocId){

                }

            });

        },
    },
    created:function(){
        var vues = this;

        // 获取商讯 type
        this.prevSet();

        this.$store.dispatch('imgStore/act_getStore');

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
  padding: 20px;
  background: white
}

.tabs{
    width: 80%;
    td{
        font-size: 15px;
        line-height: 36px;
        padding-bottom: 12px;
    }

    .ispan1{
       width: 120px;
    }

    .itext{
       color: #999999;
    }

    .stateLine td{
        padding-top: 12px;
    }

}


.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-right: 20px;
  position: relative;
  z-index: 2;
  text-align: right;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

</style>



// WEBPACK FOOTER //
// attesEdit.vue?cf2b82de